/**
 * This patch is needed to make tributejs work with trix-editor in Chrome
 *
 * Upon deleting attachment in trix-editor in chrome it will brake DOM into multiple
 * text nodes
 *
 * ```html
 * <div>
 *  "This"
 *  "is test"
 * </div>
 *  ```
 *
 * This will break tributejs and it will not be able to find the correct position
 * to trigger the dropdown for mentions
 *
 * To fix it we need to reset the value of trix-editor on trix-change event
 * after the attachment is deleted
 *
 * The fix will produce this DOM in Chrome with this patch
 * ```html
 * <div>
 *  "This is test"
 * </div>
 *  ```



 */

function collapseTextNodesPatch({ target: trixEditor }) {
  // Get the current position of trix-editor
  const position = trixEditor.editor.getPosition();

  // Read the current value of trix-editor
  const currentValue = trixEditor.value;

  // Reset the value of trix-editor so there is a difference in next step
  trixEditor.value = '';

  // Set the value back to the original value
  // trixEditor.value = currentValue;
  trixEditor.editor.loadHTML(currentValue);

  // Set the position back to the original position
  trixEditor.editor.setSelectedRange(position);
}

/**
 * This function will install the patch for trix-editor
 * install it in the trix-attachment-remove event handler
 */
export function trixTributePatchInstaller(trixEditor) {
  // To avoid unreliable setTimeout we are using trix-change event
  // which will be attached only once
  trixEditor.addEventListener('trix-change', collapseTextNodesPatch, {
    once: true,
  });
}
